import { sendToMixpanel, getUserProps } from '..';

const trackSearchInputInteraction = (): void => {
  // Spec explicitly excludes modules/modulesCount from this event only.
  sendToMixpanel('Search Input Interaction', {
    siteSection: 'Agents',
    ...getUserProps(),
  });
};

export default trackSearchInputInteraction;
